import React, { useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import XMLViewer from "react-xml-viewer";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import agent from "../../../app/api/agent";

interface IProps {
  id: string;
}

const XML: React.FC<IProps> = ({ id }) => {
  const [xml, setXml] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadXML = async () => {
      try {
        const data = await agent.Payroll.getUBLById(id);
        setXml(data);
      } catch (error) {
        console.error("Error loading XML:", error);
        setXml(null);
      } finally {
        setLoading(false);
      }
    };

    loadXML();
  }, [id]);

  const downloadHandle = async () => {
    try {
      const xmlData = await agent.Payroll.getUBLById(id);
      const blob = new Blob([xmlData], { type: "application/xml" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `payroll_${id}.xml`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading XML:", error);
    }
  };

  if (loading) {
    return <LoadingComponent content="Cargando XML..." />;
  }

  return (
    <div>
      <Button
        color="blue"
        onClick={downloadHandle}
        disabled={xml === null}
      >
        <Icon name="download" /> Descargar
      </Button>
      <br />
      <br />
      <div style={{ overflowX: "scroll" }}>
        {xml === null ? (
          <div className="noPdfDiv">
            <span>El documento no tiene un XML asociado</span>
          </div>
        ) : (
          <XMLViewer xml={xml} />
        )}
      </div>
    </div>
  );
};

export default observer(XML);
